import { IScope } from "angular";

import { ITagCollection } from "@gtmhub/tags/models";
import { TagService } from "@gtmhub/tags/tagService";
import { ITraceRootScopeService } from "@gtmhub/core/tracing";

interface IBulkTagScope extends IScope {
  tags: ITagCollection;
  createTag(tag: string);
}

export class BulkTagCtrl {
  public static $inject = ["$scope", "TagService", "$rootScope"];

  constructor(private $scope: IBulkTagScope, private tagService: TagService, private $rootScope: ITraceRootScopeService) {
    this.$scope.createTag = this.createTag;
    this.getTags();
  }

  private getTags = () => {
    this.tagService.getTags().then((tags) => {
      this.$scope.tags = tags;
    });
  };

  private createTag = (tag) => {
    this.$rootScope.traceAction("create_tag", () => {
      this.$scope.tags.tags.push({ name: tag, title: tag });
    });
  };
}
